import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import TeachersTable from '../components/teachersTable';

function PedagogicalStaff() {
  return (
    <Layout>
      <SEO
        keywords={[
          `Педагогический состав`,
          `Профф`,
          `Пыть-Ях`,
          `Профессиональное образование`,
        ]}
        title='Педагогический состав'
      />

      <section className='flex flex-col items-center '>
        <h1 className=' text-center text-xl uppercase tracking-wider text-green-800 font-bold mb-4'>
          СОСТАВ ПЕДАГОГИЧЕСКИХ РАБОТНИКОВ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ
        </h1>
        <TeachersTable />
      </section>
    </Layout>
  );
}

export default PedagogicalStaff;
